import { MonitaroGatewayBase } from '@/gateways/Monitaro/base'
import { IInvitationProps } from '@/entities/Invitation'
import { PostInvitation } from '@/infrastructure/network/Monitaro/requests/invitation'
import { toInvitationRequest } from '@/gateways/Monitaro/translator/invitation'

export default class Invitation extends MonitaroGatewayBase {
  async PostInvitation(props: IInvitationProps) {
    return await this.apiClient.request(new PostInvitation(toInvitationRequest(props)))
  }
}
